/* eslint-disable @typescript-eslint/no-unused-vars */
'use client';

import { useQuery } from 'react-query';

import { NavBar } from '@/components';
import { RecentMatchStatsSection } from '@/components/FieldAssistant/RecentMatchStatsSection';
import { getRecentMatchStats } from '@/services/fieldAssistant';

const MobileBody = () => {
  const {
    data: dataRecentMatchStats,
    isLoading: isLoadingDataRecentMatchStats,
    refetch: loadRecentMatchStats,
    status,
  } = useQuery('getRecentMatchStats', async () => await getRecentMatchStats(), {
    refetchOnWindowFocus: false,
    keepPreviousData: false,
  });
  if (isLoadingDataRecentMatchStats) {
    return <div>Cargando..</div>;
  }
  /*
  if ((dataRecentMatchStats?.partidos?.length || 0) === 0) {
    return <div>Todavía no hay partidos cargados</div>;
  } */

  return (
    <div className="flex flex-col ">
      <div className="flex justify-center mx-5 mt-3">
        <div className="bg-[Red] h-24 w-[950px] flex justify-center items-center text-base text-white font-bold">
          Banner
        </div>
      </div>
      <RecentMatchStatsSection
        matchs={dataRecentMatchStats?.partidos || []}
        variant={'DEFAULT'}
      />
      <div className="flex flex-col mx-5 gap-7 mt-7">
        <div className="bg-gdt-status-green h-56 w-11/12 mx-auto flex justify-center items-center text-base text-white font-bold">
          BANNER 1
        </div>
      </div>
    </div>
  );
};

export const RecentMatchStats = () => {
  return (
    <NavBar
      desktop
      mobile={{
        leftContent: {
          showMenuAction: true,
          items: true,
        },
        centerContent: {
          displayLogo: true,
        },
      }}
    >
      <MobileBody />
    </NavBar>
  );
};
